import githubIcon from "../assets/github-icon.svg";
import externalLink from "../assets/external-link.svg";
import htmlIcon from "../assets/html-icon.svg";
import cssIcon from "../assets/css-icon.svg";
import jsIcon from "../assets/js-icon.svg";
import reactIcon from "../assets/react-icon.svg";
import nodeIcon from "../assets/node-icon.svg";
import mysqlIcon from "../assets/mysql-icon.svg";
import typescriptIcon from "../assets/typescript-icon.svg";
import vsCodeIcon from "../assets/vscode-icon.svg";
import muiIcon from "../assets/mui-icon.svg";
import androidstudioIcon from "../assets/androidstudio-icon.svg";
import bitbucketIcon from "../assets/bitbucket-icon.svg";
import dockerIcon from "../assets/docker-icon.svg";
import firebaseIcon from "../assets/firebase-icon.svg";
import gitIcon from "../assets/git-icon.svg";
import javaIcon from "../assets/java-icon.svg";
import jiraIcon from "../assets/jira-icon.svg";
import mongodbIcon from "../assets/mongodb-icon.svg";
import laravelIcon from "../assets/laravel-icon.svg";
import phpIcon from "../assets/php-icon.svg";
import reduxIcon from "../assets/redux-icon.svg";
import symfonyIcon from "../assets/symfony-icon.svg";
import xcodeIcon from "../assets/xcode-icon.svg";
import awsIcon from "../assets/aws-icon.svg";
import anypet from "../assets/projects/anypet.png";
import ascClient from "../assets/projects/ASC_Client.png";
import ascCoach from "../assets/projects/ASC_Coach.png";
import meanEcommerce from "../assets/projects/mean-ecommerce.png";
import mernEcommerce from "../assets/projects/mern-ecommerce.png";
import paruvendu from "../assets/projects/paruvendu.png";
import reactWeatherApp from "../assets/projects/react-weather.png";
import reactNativeCitySearch from "../assets/projects/reactnative-city-search.png";
import springbootEcommerce from "../assets/projects/springboot-ecommerce.png";
import springbootMovies from "../assets/projects/springboot-movies.png";
import symfonyReactIot from "../assets/projects/symfony-react-iot.png";
import reactScoringApp from "../assets/projects/react-scoring.png";
import searchCity_reactNative from "../assets/projects/searchCity_reactNative.png";
import djangoProtfolio from "../assets/projects/django_protfolio.png";
import RiahiRamiPic from "../assets/RiahiRami.png";
import linkedinIcon from "../assets/linkedin.svg";
import developerIllustration from "../assets/developer_illustration.png";
import bootstrapIcon from "../assets/bootstrap-icon.svg";
import folderIcon from "../assets/folder-icon.svg";
import goBackIcon from "../assets/go_back_icon.png";

export const images = {
  RiahiRamiPic,
  developerIllustration,
  linkedinIcon,
  githubIcon,
  externalLink,
  folderIcon,
  goBackIcon,
  bootstrapIcon,
  htmlIcon,
  cssIcon,
  jsIcon,
  reactIcon,
  nodeIcon,
  mysqlIcon,
  typescriptIcon,
  vsCodeIcon,
  muiIcon,
  androidstudioIcon,
  bitbucketIcon,
  dockerIcon,
  firebaseIcon,
  gitIcon,
  javaIcon,
  jiraIcon,
  mongodbIcon,
  laravelIcon,
  phpIcon,
  reduxIcon,
  symfonyIcon,
  xcodeIcon,
  awsIcon,
  anypet,
  ascClient,
  ascCoach,
  meanEcommerce,
  mernEcommerce,
  paruvendu,
  reactWeatherApp,
  reactNativeCitySearch,
  springbootEcommerce,
  springbootMovies,
  symfonyReactIot,
  reactScoringApp,
  searchCity_reactNative,
  djangoProtfolio,
};
